import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import DesktopApp from './pages/desktop-app';
import Pricing from './pages/pricing';
import Contact from './pages/contact';
import { Navigate } from 'react-router-dom';
import Home from './pages/home';
import Features from './pages/features';
import About from './pages/about';
import Privacy from './pages/privacy';
import Downloads from './pages/downloads';
import Offline from './pages/offline';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Home />} />
        <Route path="/desktop-app" element={<DesktopApp />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/support-faq" element={<Contact />} />
        <Route path="/support" element={<Contact />} />
        <Route path="/contact" element={<Navigate to="/support" replace />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/offline" element={<Offline />} />
        <Route path="/home" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
